module.exports = __webpack_public_path__ + "img/workingcapital-white-text-only-powered.c5f987a7.png";